module.exports = __webpack_public_path__ + "img/marker.563f5817.png";